module.exports = __webpack_public_path__ + "static/media/mm.a2a82021.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mm.svg
// module id = 2156
// module chunks = 0